/* eslint-disable import/no-unresolved */
import { createI18n } from 'vue-i18n';
import ko from '@/i18n/ko';
import en from '@/i18n/en';
import {
  ko as vuetifyKo,
  en as vuetifyEn,
} from 'vuetify/locale';

const locale = localStorage.getItem('locale') ?? 'ko';

const i18n = createI18n({
  legacy: false,
  locale,
  messages: {
    ko: {
      ...ko,
      $vuetify: {
        ...vuetifyKo,
      },
    },
    en: {
      ...en,
      $vuetify: {
        ...vuetifyEn,
      },
    },
  },
  fallbackLocale: 'en',
});

export default i18n;
